import { useState, useEffect } from "react";
import { Link, ScrollRestoration } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/userContext";
import NavBar from "../components/NavBar/navBar.component";
import Footer from "../components/Footer/footer.component";
import { ReactComponent as InfoIcon } from "../assets/icons/info_icon.svg";
import ForgotPasswordModal from "../components/ForgotPasswordModal/forgotPasswordModal.component";

const SigninPage = () => {

  useEffect(() => {
    // Push a dummy state to the history stack
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Re-push the state to prevent back navigation
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const [isContentLoading, setIsContentLoading] = useState(false);
  const [isForgotPasswordDialogOpen, setIsForgotPasswordDialogOpen] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const handleForgotPasswordLinkClick = () => {
    setIsForgotPasswordDialogOpen(true);
  };

  const handleCloseForgotPasswordDialog = () => {
    setIsForgotPasswordDialogOpen(false);
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);

  const { keepSignedIn, setKeepSignedIn, setUserData } = useUser();

  const navigate = useNavigate();

  const handleSignInWithPhone = async (e) => {
    e.preventDefault();

    if (isForgotPasswordDialogOpen) {
      return
    }
    // Email validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setEmailError(true);
      return;
    }

    // Clear any previous email error
    setEmailError(false);

    try {

      setIsContentLoading(true);

      // Make a POST request to your server-side API endpoint for sign-in using Axios
      const response = await axios.post(
        "https://soliboat.solidaridadasia.com/sign-in",
        {
          email: email,
          password: password,
        }
      );

      // Check the response from the server to see if sign-in was successful
      if (response.status === 200 && response.data.success) {
        setUserData(response.data.data[0]);

        // Redirect the user to another page or perform other actions
        navigate("/dashboard");
      } else {
        // If sign-in failed, show an error message
        console.error("Sign-in failed:", response.data.message[0]);
        alert("Sign-in failed. Please check your credentials.");
      }
    } catch (error) {
      console.error(
        "Error occurred during sign-in:",
        error.response.data.errors[0]
      );
      alert(error.response.data.errors[0]);
    } finally {
      // Clear the phone number and password inputs after sign-in attempt
      setEmail("");
      setPassword("");
      setIsContentLoading(false);
    }
  };

  return (
    <>
      {isContentLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-50 z-[100]">
          <div className="w-20 h-20 animate-spin">
            <div className="h-full w-full border-4 border-t-dark/50 border-b-dark/80 rounded-[50%]" />
          </div>
          <div className="text-center text-sm lg:text-xl font-medium text-gray-500 mt-8 mx-8 lg:mx-0">
            Please wait while while we process your request{" "}
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
          </div>
        </div>
      )}
      <ScrollRestoration />
      <NavBar />
      <section className={`relative ${!isForgotPasswordDialogOpen ? "z-10" : "z-50"} overflow-hidden pt-36 pb-16 md:pb-20 lg:pt-[180px] lg:pb-28`}>
        <div className="container">
          <div className="-mx-4 flex flex-wrap">
            <div className="w-full px-4">
              <div className="mx-auto max-w-[500px] rounded-md bg-primary bg-opacity-5 py-10 px-6 dark:bg-dark sm:p-[60px]">
                <h3 className="mb-3 text-center text-2xl font-bold text-black dark:text-white sm:text-3xl">
                  Sign in to your account
                </h3>
                <p className="mb-11 text-center text-base font-medium text-body-color">
                  Please enter your login information.
                </p>
                <form onSubmit={handleSignInWithPhone}>
                  <div className="mb-8">
                    <label
                      htmlFor="tel"
                      className="mb-3 block text-sm font-medium text-dark dark:text-white"
                    >
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                    />
                    {emailError && (
                      <div className="flex items-center mt-3">
                        <InfoIcon className="w-6 h-6" />
                        <span className="text-red text-sm ml-2">
                          Please enter a valid email.
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="mb-8">
                    <label
                      htmlFor="password"
                      className="mb-3 block text-sm font-medium text-dark dark:text-white"
                    >
                      Your Password
                    </label>
                    <div className="flex">
                      <input
                        type={showPwd ? 'text' : 'password'}
                        name="password"
                        placeholder="Enter your Password"
                        // value={password} // Bind the 'value' attribute to the password state variable
                        onChange={(e) => setPassword(e.target.value)} // Update the password state when input changes
                        className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                      />
                      {
                        showPwd ?
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-7 w-7 m-4" onClick={() => { setShowPwd(!showPwd) }}>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                          </svg>
                          :
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-7 w-7 m-4" onClick={() => { setShowPwd(!showPwd) }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                          </svg>
                      }
                    </div>
                  </div>
                  <div className="mb-8 flex flex-col justify-between sm:flex-row sm:items-center">
                    <div className="mb-4 sm:mb-0">
                      <label
                        htmlFor="checkboxLabel"
                        className="flex cursor-pointer select-none items-center text-sm font-medium text-body-color"
                      >
                        <div className="relative">
                          <input
                            type="checkbox"
                            id="checkboxLabel"
                            checked={keepSignedIn}
                            onChange={() => setKeepSignedIn(!keepSignedIn)}
                            className="sr-only"
                          />
                          <div className="box mr-4 flex h-5 w-5 items-center justify-center rounded border border-body-color border-opacity-80 dark:border-white dark:border-opacity-10">
                            <span className="opacity-0">
                              <svg
                                width="11"
                                height="8"
                                viewBox="0 0 11 8"
                                fill="none"
                                xmlns="https://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                  fill="#3056D3"
                                  stroke="#3056D3"
                                  strokeWidth="0.4"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                        Keep me signed in
                      </label>
                    </div>
                    <div>
                      <Link
                        className="text-sm font-medium text-primary hover:underline"
                        onClick={handleForgotPasswordLinkClick}
                      >
                        Forgot Password?
                      </Link>
                    </div>
                    {isForgotPasswordDialogOpen && (
                      <ForgotPasswordModal onClose={handleCloseForgotPasswordDialog} />
                    )}
                  </div>
                  <div className="mb-6">
                    <button className="flex w-full items-center justify-center rounded-md bg-primary py-4 px-9 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp">
                      Sign in
                    </button>
                  </div>
                </form>
                <p className="text-center text-base font-medium text-body-color">
                  Don’t you have an account?
                  <Link
                    to="/signup"
                    className="text-primary hover:underline ml-1"
                  >
                    Sign up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 z-[-1]">
          <svg
            width="1440"
            height="969"
            viewBox="0 0 1440 969"
            fill="none"
            xmlns="https://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_95:1005"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="1440"
              height="969"
            >
              <rect width="1440" height="969" fill="#090E34" />
            </mask>
            <g mask="url(#mask0_95:1005)">
              <path
                opacity="0.1"
                d="M1086.96 297.978L632.959 554.978L935.625 535.926L1086.96 297.978Z"
                fill="url(#paint0_linear_95:1005)"
              />
              <path
                opacity="0.1"
                d="M1324.5 755.5L1450 687V886.5L1324.5 967.5L-10 288L1324.5 755.5Z"
                fill="url(#paint1_linear_95:1005)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_95:1005"
                x1="1178.4"
                y1="151.853"
                x2="780.959"
                y2="453.581"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4A6CF7" />
                <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_95:1005"
                x1="160.5"
                y1="220"
                x2="1099.45"
                y2="1192.04"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4A6CF7" />
                <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SigninPage;
